import { Card, EmptyState, LoadingLine } from '@wundo/ui';
import type { ColleagueRelationship, OneOnOneColleagueItem } from '@/lib/colleagues.ts';
import { m } from '@/paraglide/messages.js';
import { OneOnOneCard } from './OneOnOneCard.tsx';
import { TeamListHeader } from './TeamListHeader.tsx';
import type { TeamFilter } from './teamFilter.ts';
import type { TeamList } from './useTeamColleagues.ts';

export interface TeamColleagueListProps {
  list: TeamList;
  /** Which selection is showing, for the empty line. */
  filter: TeamFilter;
  onSupportChange: (colleague: OneOnOneColleagueItem, supported: boolean) => void;
  onRelationshipChange: (
    colleague: OneOnOneColleagueItem,
    relationship: ColleagueRelationship,
  ) => void;
}

/** The colleagues the toolbar selected, a card each. */
export function TeamColleagueList({
  list,
  filter,
  onSupportChange,
  onRelationshipChange,
}: TeamColleagueListProps) {
  switch (list.kind) {
    case 'loading':
      return <LoadingLine label={m.team_loading()} className='mt-4 px-1 py-2' />;
    case 'failed':
      return (
        <p className='mt-4 px-1 py-2 text-base text-danger'>{m.team_hidden_failed()}</p>
      );
    case 'empty':
      return (
        <Card tone='quiet' className='mt-4'>
          <EmptyState
            className='py-4'
            title={filter === 'hidden' ? m.team_hidden_empty() : m.team_filter_empty()}
          />
        </Card>
      );
    case 'cards':
      return (
        <>
          <TeamListHeader />
          <ul aria-label={m.nav_team()} className='mt-2 flex flex-col gap-2.5'>
            {list.colleagues.map((colleague) => (
              <OneOnOneCard
                key={colleague.id}
                colleague={colleague}
                onSupportChange={(supported) => onSupportChange(colleague, supported)}
                onRelationshipChange={(relationship) =>
                  onRelationshipChange(colleague, relationship)
                }
              />
            ))}
          </ul>
        </>
      );
  }
}
